import { useCallback, useEffect, useState } from 'react';

export function useScrollToCardEffect<T extends HTMLElement>(cardIndex: number, contentBodyRef: React.RefObject<T>) {
    const { cardWidth } = useFirstCard(contentBodyRef);
    const left = cardIndex * cardWidth;

    useEffect(() => {
        if (!contentBodyRef.current || !cardWidth) return;

        contentBodyRef.current.scrollTo({
            left,
            behavior: 'smooth'
        });
    });
}

export function useFirstCard<T extends HTMLElement>(contentBodyRef: React.RefObject<T>) {
  const [cardWidth, setCardWidth] = useState<number | null>(null);

  useEffect(() => {
    const contentBody = contentBodyRef.current;
    if (!contentBody) return;

    const first = contentBody.children[0] as HTMLElement | undefined;
    if (!first) return;

    const gap = parseFloat(getComputedStyle(contentBody).gap ?? '0');
    setCardWidth(first.offsetWidth + gap);
  }, [contentBodyRef]);

  const setFocus = useCallback(() => {
    const first = contentBodyRef.current?.children[0] as HTMLElement;
    first?.focus();
  }, [contentBodyRef]);

  return { cardWidth, setFocus };
}